import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Typography, CircularProgress, Box } from '@material-ui/core';
import styles from './home.module.scss';
import { useStoreState } from 'easy-peasy';
import { stringConstants } from '../../constants/stringConstants';
import checkpointLogo from '../../assets/images/checkpoint.png';
import policyLogo from '../../assets/images/policy-mgmt.png';
import autoAuthLogo from '../../assets/images/auto-auth.png';
import clinicalAssistantLogo from '../../assets/images/clinical-asstnt.png';
import { ROLES, redirectUserWithToken } from '../../submodule';

const Home = (props) => {
  const userInfoData = useStoreState((state) => state.login?.userInfo);
  const [userProductList, setUserProductList] = useState([]);
  const [loader, setLoader] = useState(false);

  const goToPage = (e, item) => {
    setLoader(true);
    redirectUserWithToken(item.url, false, e.ctrlKey ? true : false);
    setTimeout(() => {
      setLoader(false);
    }, 5000);
  };

  useEffect(() => {
    if(userInfoData.permissions && Object.keys(userInfoData.permissions).length !== 0) {
      const resList = userInfoData.products && userInfoData.products.length > 0 && userInfoData.products.filter((elem) => Object.keys(userInfoData.permissions).find((element ) => elem.code === element));
      setUserProductList(resList);
    }
  }, [userInfoData.products, userInfoData.permissions]);

  return (
    <Grid container alignItems="center" justifyContent="center" className={styles.homeMain}>
      {loader && (
        <Box className={styles.loaderWrapper}>
          <Grid item xs={12} md={12} lg={12} className={styles.loader} align='center'>
            <Typography variant="h6" component="h6" className={styles.loadHomeTiles}>Redirect to product</Typography>
            <CircularProgress />
          </Grid>
        </Box>
      )}
      <Grid item xs={10} className={styles.homeWrapper}>
        <Grid container justifyContent="center" alignItems="center" spacing={4}>
          {userInfoData.PK ? (
            <>
              <Grid item xs={12} md={12} lg={12} align='center'>
                <Grid container direction="row" justifyContent="center">
                  <Grid item xs={12} md={12} lg={12} align='center'>
                    <Typography variant="h5" component="h5" className={styles.welcomeProductTitle}>
                      Welcome, {`${userInfoData?.firstname} ${userInfoData?.lastname}!`}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={9} md={9} lg={9} align='center'>
                    <Typography variant="body2" className={styles.welcomeProductText}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</Typography>
                  </Grid> */}
                </Grid>
              </Grid>
              {userProductList && userProductList.length > 0 ? (
                <>
                  {userProductList.filter(i => i.code.toUpperCase() !== 'PROVIDER_PORTAL').map((item, index) => (
                    <Grid key={index} item xs={12} sm={6} md={6} lg={3} className={styles.productWrapper} onClick={(e) => { goToPage(e, item) }}>
                      <Grid item md={12} align='center'>
                        <img className={styles.productImage} src={item.code === 'CHECKPOINT' ? checkpointLogo : item.code === 'POLICIES' ? policyLogo : item.code === 'CLINICAL-ASSISTANT' ? clinicalAssistantLogo : item.code === 'AUTO' ? autoAuthLogo : autoAuthLogo} />
                      </Grid>
                      <Grid item md={12} align='center'>
                        <Typography variant="h3" component="h3" className={styles.productText}>{item.title =="Policy"?'Policy Management':item.title}</Typography>
                      </Grid>
                    </Grid> 
                  ))}
                </>
              ) : (
                <Typography variant="body5">
                  {userInfoData && userInfoData.roles && userInfoData.roles.sso_title !== ROLES.PLATFORM_ADMIN && (
                    <>Looks like there are no products assigned to you. Please contact your Admin.</>
                  )}
                </Typography>
              )}
            </>
          ) : (
            <>
              <Typography className={styles.loadHomeTiles}>{stringConstants.LoadingText}</Typography>
              <CircularProgress />
            </>
          )}
        </Grid>
      </Grid>     
    </Grid>
  );
};

export default withRouter(Home);
